



































































import { DialogMixin, ModelEditableMixin } from "../../../components/system";
import { Component, Mixins } from "vue-property-decorator";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import { StandardOption } from "../../system/selectors/mixins";
import { PresetSortConditionItem } from "../../../domain/document";
import ListMultiSortConditionPresetNameDialog from "./ListMultiSortConditionPresetNameDialog.vue";

export interface IListMultiSortConditionDialogParameter<T> {
  isEdit: boolean;
  presetName: string;
  sortConditionItems: PresetSortConditionItem[];
  sortTypeOptions: StandardOption<T>[];
  defaultSort: boolean;
  isSortButtonEnable: boolean;
}

export interface IListMultiSortConditionDialogResult {
  result: "sort" | "add" | "rename" | "remove" | "update" | "cancel";
  presetName: string;
  sortConditionItems: PresetSortConditionItem[];
  defaultSort: boolean;
}

@Component({
  components: {
    OptionDropDownSelector,
    ListMultiSortConditionPresetNameDialog,
  }
})
export default class ListMultiSortConditionDialog<T> extends Mixins(ModelEditableMixin, DialogMixin) {
  private static readonly maxSize = 3;

  data(): any {
    return {
      isEdit: false,
      presetName: "",
      sortConditionItems: [],
      sortTypeOptions: [],
      defaultSort: false,
      result: "cancel",
      isSortButtonEnable: false,
    };
  }
  isEdit: boolean;
  presetName: string;
  sortConditionItems: PresetSortConditionItem[];
  sortTypeOptions: StandardOption<T>[];
  defaultSort: boolean = false;
  result: "sort" | "add" | "rename" | "remove" | "update" | "cancel";
  isSortButtonEnable: boolean;

  $refs!: {
    presetNameDialog: ListMultiSortConditionPresetNameDialog,
  };

  get title(): string {
    return this.isEdit || !this.isSortButtonEnable
      ? "プリセット設定"
      : "並べ替え";
  }

  get isDuplicate(): boolean {
    return this.sortConditionItems.some((v, i) => this.duplicate(v.sortType, i));
  }

  async show(param: IListMultiSortConditionDialogParameter<T>): Promise<IListMultiSortConditionDialogResult> {
    await this.showModal(async () => {
      this.isEdit = param.isEdit;
      this.presetName = param.presetName;
      this.sortConditionItems = this.fillSortItems(param.sortConditionItems);
      this.sortTypeOptions = param.sortTypeOptions;
      this.defaultSort = param.defaultSort;
      this.isSortButtonEnable = param.isSortButtonEnable;
      this.result = "cancel";
      await this.waitHidden(); 
    });
    return {
      result: this.result,
      presetName: this.presetName,
      sortConditionItems: this.sortConditionItems.filter(v => v.sortType !== null),
      defaultSort: this.defaultSort,
    };
  }

  private fillSortItems(items: PresetSortConditionItem[]): PresetSortConditionItem[] {
    // 複製して処理する
    const ret = items.map(v => {
      const model = new PresetSortConditionItem();
      model.sortType = v.sortType;
      model.orderType = v.orderType;
      return model;
    });
    while (ret.length < ListMultiSortConditionDialog.maxSize) {
      const model = new PresetSortConditionItem();
      model.sortType = null;
      model.orderType = "ascending";
      ret.push(model);
    }
    return ret;
  }

  duplicate(sortType: T, index: number): boolean {
    return this.sortConditionItems.some((v, i) => sortType !== null && v.sortType === sortType && i !== index);
  }

  async rename(): Promise<void> {
    const dialog = await this.$refs.presetNameDialog.show({
      isAdd: false,
      presetName: this.presetName,
      isEditDefault: false,
    });
    if (!dialog.result) {
      return;
    }
    this.result = "rename";
    this.presetName = dialog.presetName;
    this.isVisible = false;
  }

  async add(): Promise<void> {
    const dialog = await this.$refs.presetNameDialog.show({
      isAdd: true,
      presetName: "",
      isEditDefault: true,
    });
    if (!dialog.result) {
      return;
    }
    this.result = "add";
    this.presetName = dialog.presetName;
    this.defaultSort = dialog.defaultSort;
    this.isVisible = false;
  }

  sort() {
    this.result = "sort";
    this.isVisible = false;
  }

  async remove() {
    const confirmationResult = await this.$commonDialogs.confirmation.confirmDeleteCancel(
      "削除確認",
      ["プリセットを削除してもよろしいですか？"],
    );
    if (confirmationResult !== 0) { return; }
    this.result = "remove";
    this.isVisible = false;
  }

  async saveAs(): Promise<void> {
    const dialog = await this.$refs.presetNameDialog.show({
      isAdd: true,
      presetName: this.presetName,
      isEditDefault: false,
    });
    if (!dialog.result) {
      return;
    }
    this.result = "add";
    this.presetName = dialog.presetName;
    this.isVisible = false;
  }

  save() {
    this.result = "update";
    this.isVisible = false;
  }

  cancel() {
    this.result = "cancel";
    this.isVisible = false;
  }
}
